import { Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FullLayout from '../layouts/FullLayout';
import { getOneUser, addingUser, updateUser } from "../services/userServices";
import Toast from 'react-bootstrap/Toast';
import { RoleContext, AlertContext } from "../utils/contexts/RoleContext";
import Header from "../layouts/Header";
import Layout from '../layouts/Layout';

export default function TermsAndConditions() {
    return (
        // <FullLayout>
        <>
        <Layout>
        
        <div className="ul-tag p-5">
            <h2>Terms and Conditions for Corsia Wallet</h2>
            <Col className="mt-3 mb-4">
                <div className="px-4 mt-3 mb-4 pt-3">
                    <p className="p-1">Welcome to <span className="fw-bold">Corsia Wallet.</span> By using our mobile application and services, you agree to the following
                        Terms and Conditions. Please read them carefully before proceeding.
                    </p>
                    <h3 className="mt-3">1. Introduction</h3>
                    <p className="mt-3">These Terms and Conditions govern your access and use of the, <span className="fw-bold">Corsia Wallet </span>mobile application and
                        associated services. By registering an account or using the app, you acknowledge that you have read,
                        understood, and agreed to these terms.</p>
                    <p className="mt-3">If you do not agree with any part of these terms, please do not use the app.
                    </p>

                    <h3 className="mt-4">2. Eligibility
                    </h3>
                    <p className="mt-3">To use <span className="fw-bold">Corsia Wallet,</span> you must:
                    </p>
                    <ul className="">
                        <li className="p-1">Be at least <span className="fw-bold">18 years old </span>or the legal age of majority in your country.</li>
                        <li className="p-1">Provide accurate and up-to-date KYC information as required.

                        </li>
                        <li className="p-1">Comply with all applicable laws and regulations related to cryptocurrency transactions.
                        </li>

                    </ul>
                    <p className="mt-3">We reserve the right to <span className="fw-bold"> suspend or terminate accounts </span>if any eligibility criteria are not met</p>

                    <h3 className="mt-4">3. Account Registration & Security
                    </h3>

                    <ul className="">
                        <li className="p-1">Users need to complete <span className="fw-bold">KYC verification </span>by submitting valid identification documents</li>
                        <li className="p-1">Users are responsible for maintaining the <span className="fw-bold"
                        >confidentiality</span>  of their account credentials
                        </li>
                        <li className="p-1"><span className="fw-bold">Unauthorized access</span> or suspicious activity must be reported to
                            <a className="link-opacity-10 text-primary" href="mailto:Support@v-b-h.com"> Support@v-b-h.com </a>immediately.
                        </li>
                        <li className="p-1">The company is <span className="fw-bold"
                        >not liable for losses </span>due to compromised credentials or unauthorized
                            transactions.
                        </li>
                    </ul>

                    <h3 className="mt-4">4. Services Provided</h3>
                    <p className="mt-3">Corsia Wallet allows users to:
                    </p>
                    <ul className="">
                        <li className="p-1"><span className="fw-bold">Buy and sell Corsia tokens </span>within the app
                        </li>
                        <li className="p-1"><span className="fw-bold">Deposit and withdraw USDT </span>(processed manually by the admin).
                        </li>
                        <li className="p-1">View<span className="fw-bold"> real-time balances </span>for USDT and Corsia.
                        </li>
                        <li className="p-1"><span className="fw-bold">Track transaction history, </span>including completed, pending, and failed transactions
                        </li>
                    </ul>
                    <p className="mt-3">All transactions are<span className="fw-bold"> subject to approval </span>by the admin and may take up to 
                        <span className="fw-bold"> 15 minutes </span>for processing.
                    </p>

                    <h3 className="mt-4">5. Transactions & Fees
                    </h3>

                    <ul className="">
                        <li className="p-1"><span className="fw-bold">Corsia token prices are set by the admin</span> and may fluctuate.
                        </li>
                        <li className="p-1"><span className="fw-bold"
                        >USDT transactions</span> are manually verified and processed by the admin.
                        </li>
                        <li className="p-1">Any<span className="fw-bold"> applicable fees</span> (e.g., withdrawal fees, admin fees) will be displayed before confirming
                            transactions.
                        </li>
                        <li className="p-1">Users<span className="fw-bold"> cannot initiate transactions beyond their available balance.</span>
                        </li>

                    </ul>
                    <p className="mt-3">We are not responsible for <span className="fw-bold">  price fluctuations </span>or any financial losses incurred due to trading
                        decisions.</p>

                    <h3 className="mt-4">6. Deposits & Withdrawals
                    </h3>
                    <ul className="">
                        <li className="p-1"><span className="fw-bold">Deposits require users to submit a request</span> and upload a proof of transaction (screenshot).
                        </li>
                        <li className="p-1">
                            Withdrawals are <span className="fw-bold">subject to manual verification and approval </span>by the admin.
                        </li>
                        <li className="p-1"><span className="fw-bold">Incorrect or incomplete withdrawal details</span> may result in processing delays or failed
                            transactions.
                        </li>
                        <li className="p-1">Users must <span className="fw-bold"> double-check wallet addresses</span>before sending funds, as transactions <span className="fw-bold">cannot be
                            reversed.</span>
                        </li>
                    </ul>
                    <p className="mt-3">The company is <span className="fw-bold"> not responsible for losses </span>due to incorrect wallet addresses or external service
                        issues.

                    </p>

                    <h3 className="mt-4">7. Account Suspension & Termination</h3>
                    <p className="mt-3">We may <span className="fw-bold">suspend or terminate </span> user accounts under the following circumstances:</p>
                    <ul className="">
                      
                        <li className="p-1">
                            Submission of <span className="fw-bold">false or fraudulent KYC information. </span>
                        </li>
                        <li className="p-1"><span className="fw-bold">Violation of terms,</span> including unauthorized transactions or suspicious activity.
                        </li>
                        <li className="p-1"><span className="fw-bold">Engagement in illegal activities, </span>including money laundering or fraud.
                        </li>
                    </ul>
                    <p className="mt-3">Users can request account deactivation or <span className="fw-bold">retirement </span>through the <span className="fw-bold">Retire </span>feature in the app. Once
                        approved, the account will be permanently disabled.


                    </p>

                    <h3 className="mt-4">8. Limitation of Liability
                    </h3>
                    <ul className="">
                        <li className="p-1"><span className="fw-bold">Corsia Wallet</span> is not responsible for any <span className="fw-bold">financial losses </span>incurred while using the app
                        </li>
                        <li className="p-1">
                            We do not guarantee <span className="fw-bold">continuous availability </span>of the platform and may perform maintenance
                            or upgrades.

                        </li>
                        <li className="p-1">We are<span className="fw-bold"> not liable for third-party issues, </span>such as blockchain network failures or external
                            wallet errors.
                        </li>

                    </ul>
                    <p className="mt-3">Users accept full responsibility for their trading and transaction decisions.
                    </p>

                    <h3 className="mt-4">9. Privacy & Data Protection
                    </h3>
                    <p className="mt-3">We collect and store user data as outlined in our <span className="fw-bold">Privacy Policy. </span></p>

                    <ul className="">
                        <li className="p-1">Personal information is used for<span className="fw-bold"> KYC verification and transaction processing.</span>
                        </li>
                        <li className="p-1">
                            We implement <span className="fw-bold">security measures</span>to protect user data but cannot guarantee absolute
                            protection against cyber threats.

                        </li>
                        <li className="p-1">Users must ensure their <span className="fw-bold"> devices and login credentials</span> remain secure.
                        </li>

                    </ul>
                    <p className="mt-3">For details, please review our <span className="fw-bold">Privacy Policy</span> at <a className="link-opacity-10 text-primary" href="/privacy-policy">Corsia Wallet Privacy Policy.
                    </a>
                    </p>

                    <h3 className="mt-4">10. Changes to Terms
                    </h3>
                    <p className="mt-3">We reserve the right to modify or update these <span className="fw-bold">Terms and Conditions </span>at any time.</p>

                    <ul className="">
                        <li className="p-1">Users will be notified of major changes via email or app notifications.
                        </li>
                        <li className="p-1">Continued use of the app after modifications means you accept the updated terms.</li>

                    </ul>


                    <h3 className="mt-4">11. Contact Information</h3>
                    <p className="mt-3">For any questions or support, please contact us:
                    </p>

                    <ul className="list-group">
                        <li className="p-1"><span className="fw-bold"
                        >Email: </span> <a className="link-opacity-10 text-primary" href="mailto:Support@v-b-h.com">Support@v-b-h.com</a>
                        </li>
                        <li className="p-1"><span className="fw-bold">Website:</span><a className="link-opacity-10 text-primary" href="#">  Corsia Wallet
                        </a>
                        </li>
                    </ul>
                    <p className="mt-3">By using<span className="fw-bold"> Corsia Wallet,</span> you acknowledge that you have read and agreed to these Terms and
                        Conditions.
                    </p>
                </div>
            </Col>
        </div>
        </Layout>
        </>

    );
}